(() => {
  const drawer = document.getElementById('product-drawer');
  const labels = JSON.parse(document.getElementById('tif-overlay-labels').textContent);
  const content = drawer.querySelector('[data-drawer-content]');
  const status = drawer.querySelector('[data-drawer-status]');
  const fullLink = drawer.querySelector('[data-product-page]');
  const privacy = document.getElementById('privacy-card');
  let controller, returnFocus, baseTitle = document.title;
  const movePrivacy = () => {
    if (!privacy) return;
    ([...document.querySelectorAll('dialog[open]')].at(-1) || document.body).append(privacy);
  };
  const dismiss = () => {
    controller?.abort();
    if (drawer.open) drawer.close();
    document.documentElement.classList.remove('product-open');
    content.replaceChildren(); status.textContent = '';
    document.title = baseTitle;
    movePrivacy();
    if (returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
  };
  async function openProduct(url, addHistory, trigger) {
    controller?.abort(); controller = new AbortController();
    const signal = controller.signal;
    if (!drawer.open) {
      baseTitle = document.title;
      returnFocus = trigger || returnFocus;
      drawer.showModal();
      document.documentElement.classList.add('product-open');
    }
    drawer.scrollTop = 0; content.replaceChildren();
    status.textContent = labels.loading;
    fullLink.href = url;
    movePrivacy();
    if (addHistory) history.pushState({...history.state, tifProduct:url}, '', url);
    try {
      // Fetch the configured product page so product app blocks retain their settings.
      const response = await fetch(url, {signal, credentials:'same-origin'});
      if (!response.ok) throw new Error('Product unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const product = page.querySelector('.product-experience');
      if (!product) throw new Error('Product markup unavailable');
      if (signal.aborted) return;
      ['ProductForm','ProductVariant','ProductQuantity'].forEach(id=>{
        const field=product.querySelector('#'+id);if(field)field.id='drawer-'+id;
        product.querySelectorAll('[for="'+id+'"]').forEach(label=>label.htmlFor='drawer-'+id);
      });
      content.replaceChildren(product);
      status.textContent = '';
      document.title = page.title;
      drawer.querySelector('[data-close-product]').focus({preventScroll:true});
      document.dispatchEvent(new CustomEvent('tif:product-loaded',{detail:{container:content}}));
    } catch (error) {
      if (signal.aborted) return;
      status.textContent = labels.error;
      fullLink.focus();
    }
  }
  const requestClose = () => {
    if (history.state?.tifProduct) history.back(); else dismiss();
  };
  document.addEventListener('click', e => {
    if (e.target.closest('[data-close-zoom]')) {document.getElementById('image-zoom').close();movePrivacy();return;}
    const zoom=e.target.closest('[data-image-zoom]');if(zoom && !e.metaKey && !e.ctrlKey){e.preventDefault();const modal=document.getElementById('image-zoom');const img=modal.querySelector('img');img.src=zoom.href;img.alt=zoom.querySelector('img')?.alt || labels.zoom;modal.showModal();movePrivacy();return;}
    if (e.target.closest('[data-close-product]')) {requestClose();return;}
    const link = e.target.closest('.editorial-card a, .related-link, .colour-sibling');
    if (!link || drawer.dataset.enabled !== 'true' || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target === '_blank') return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
    e.preventDefault();
    if (drawer.open) {history.replaceState({...history.state,tifProduct:url.href},'',url);openProduct(url.href,false);} else openProduct(url.href, true, link);
  });
  drawer.addEventListener('cancel', e => {e.preventDefault();requestClose();});
  drawer.addEventListener('click', e => {
    if (e.target !== drawer) return;
    const box = drawer.getBoundingClientRect();
    if (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom) requestClose();
  });
  window.addEventListener('popstate', () => {
    if (history.state?.tifProduct) openProduct(history.state.tifProduct, false);
    else if (drawer.open) dismiss();
  });
  drawer.addEventListener('submit', async e => {
    if (!e.target.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    const form = e.target, button = form.querySelector('[data-add-product]');
    if (button.disabled) return;
    button.disabled = true;
    let result = form.querySelector('[data-add-result]');
    if (!result) {result = document.createElement('p');result.className='notice';result.dataset.addResult='';result.setAttribute('role','status');form.append(result);}
    result.textContent = labels.loading;
    try {
      const endpoint = new URL(form.action);endpoint.pathname += '.js';
      const response = await fetch(endpoint,{method:'POST',body:new FormData(form),credentials:'same-origin',headers:{Accept:'application/json'}});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || labels.error);
      result.textContent = labels.added + ' ';
      const bag = document.createElement('a');bag.href=(window.Shopify?.routes?.root || '/')+'cart';bag.textContent=labels.cart;result.append(bag);
      try {
        const cartResponse = await fetch((window.Shopify?.routes?.root || '/')+'cart.js');
        const cart = await cartResponse.json();
        document.querySelectorAll('.utility a[href$="/cart"]').forEach(a => a.textContent = cart.item_count ? `BAG (${cart.item_count})` : 'BAG');
      } catch { /* The added item is already confirmed; the bag link remains usable. */ }
    } catch (error) {result.textContent=error.message || labels.error;}
    finally {const select=form.querySelector('[data-variant-select]');button.disabled=select.disabled || select.selectedOptions[0]?.dataset.available !== 'true';}
  });
  if (!privacy) return;
  let api;
  const options = privacy.querySelector('.privacy-options');
  const showPrivacy = (manage=false) => {
    if (api) {
      const current = api.currentVisitorConsent();
      privacy.querySelectorAll('input[type=checkbox]').forEach(input => input.checked=current[input.name] === 'yes');
    }
    options.hidden=!manage;
    privacy.querySelector('[data-consent=save]').hidden=!manage;
    privacy.querySelector('[data-consent=manage]').hidden=manage;
    privacy.hidden=false;movePrivacy();
  };
  document.addEventListener('click', e => {
    if (e.target.closest('[data-privacy-open]')) showPrivacy(true);
    if (e.target.closest('[data-open-menu]')) movePrivacy();
    const button=e.target.closest('[data-consent]');if (!button) return;
    if (button.dataset.consent === 'manage') {showPrivacy(true);return;}
    if (!api) {privacy.querySelector('.privacy-error').hidden=false;return;}
    const values={};
    privacy.querySelectorAll('input[type=checkbox]').forEach(input => values[input.name]=button.dataset.consent === 'save' ? input.checked : button.dataset.consent === 'accept');
    privacy.querySelectorAll('button').forEach(b=>b.disabled=true);
    let completed=false;
    const timer=setTimeout(()=>{if (!completed) {privacy.querySelector('.privacy-error').hidden=false;privacy.querySelectorAll('button').forEach(b=>b.disabled=false);}},8000);
    try {
      api.setTrackingConsent(values, result => {
        if (result?.error) {completed=true;clearTimeout(timer);privacy.querySelector('.privacy-error').hidden=false;privacy.querySelectorAll('button').forEach(b=>b.disabled=false);return;}
        completed=true;clearTimeout(timer);privacy.hidden=true;
        privacy.querySelector('.privacy-error').hidden=true;
        privacy.querySelectorAll('button').forEach(b=>b.disabled=false);
      });
    } catch {clearTimeout(timer);privacy.querySelector('.privacy-error').hidden=false;privacy.querySelectorAll('button').forEach(b=>b.disabled=false);}
  });
  document.addEventListener('close', movePrivacy, true);
  const init = () => {
    if (!window.Shopify?.loadFeatures) return;
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
      if (error) return;
      api=window.Shopify.customerPrivacy;
      const current=api.currentVisitorConsent();
      const decided=['analytics','marketing','preferences'].some(key=>current[key] === 'yes' || current[key] === 'no');
      if (api.shouldShowBanner() || (privacy.dataset.allRegions === 'true' && !decided)) showPrivacy();
    });
  };
  if (document.readyState === 'complete') init(); else window.addEventListener('load',init,{once:true});
})();
